<template>
  <div style="background:#fff; padding:20px;">
    <div style="margin-bottom: 20px">
      <a-button type="primary" icon="plus" v-permission="'system:dict:add'" @click="handleAdd">新增字典</a-button>
      <a-button type="default" icon="reload" style="margin-left:10px" @click="loadData">刷新</a-button>
    </div>

    <a-table 
      :columns="columns" 
      :data-source="data" 
      rowKey="id" 
      :loading="loading" 
      :pagination="pagination"
      @change="handleTableChange"
    >
      <span slot="status" slot-scope="text">
        <a-tag v-if="text===1" color="green">启用</a-tag>
        <a-tag v-else color="red">禁用</a-tag>
      </span>

      <span slot="action" slot-scope="text, record">
        <a v-permission="'system:dict:update'" @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" v-permission="'system:dict:update'" />
        <a-popconfirm title="确定要删除吗?" @confirm="handleDelete(record.id)">
          <a style="color: red" v-permission="'system:dict:delete'">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal 
      v-model="visible" 
      :title="form.id ? '编辑字典' : '新增字典'" 
      @ok="handleOk"
    >
      <a-form-model :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="字典名称">
          <a-input v-model="form.name" placeholder="例如：性别" />
        </a-form-model-item>
        <a-form-model-item label="字典类型">
          <a-input v-model="form.type" placeholder="例如：sys_user_sex" />
        </a-form-model-item>
        <a-form-model-item label="标签">
          <a-input v-model="form.label" placeholder="例如：男" />
        </a-form-model-item>
        <a-form-model-item label="键值">
          <a-input v-model="form.value" placeholder="例如：1" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="form.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="form.sort" :min="0" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea v-model="form.remark" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { getDictList, saveDict, deleteDict } from '@/api'
import { retreatPageAfterDelete } from '@/utils/pagination'

export default {
  data() {
    return {
      data: [],
      loading: false,
      visible: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      form: {
        status: 1,
        sort: 0
      },
      columns: [
        { title: '字典名称', dataIndex: 'name' },
        { title: '类型', dataIndex: 'type' },
        { title: '标签', dataIndex: 'label' },
        { title: '键值', dataIndex: 'value' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } },
        { title: '排序', dataIndex: 'sort' },
        { title: '备注', dataIndex: 'remark' },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      getDictList({
        page: this.pagination.current,
        size: this.pagination.pageSize
      }).then(res => {
        // 假设后端返回格式 { records: [], total: 0 } 或直接 []
        if (res.data.records) {
             this.data = res.data.records
             this.pagination.total = res.data.total
        } else {
             // 兼容不分页的列表返回
             this.data = res.data
             this.pagination.total = res.data.length
        }
        this.loading = false
      })
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    handleAdd() {
      this.form = { status: 1, sort: 0 }
      this.visible = true
    },
    handleEdit(record) {
      this.form = { ...record }
      this.visible = true
    },
    handleDelete(id) {
      deleteDict({ id }).then(() => {
        this.$message.success('删除成功')
        retreatPageAfterDelete(this.pagination, this.data.length)
        this.loadData()
      })
    },
    handleOk() {
      if (!this.form.name || !this.form.type || !this.form.label || !this.form.value) {
        this.$message.error('请填写完整信息')
        return
      }
      saveDict(this.form).then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.loadData()
      })
    }
  }
}
</script>
